module.exports.search = '\
    <div class="decathlon-woosmap-container-search">\
        <div class="decathlon-woosmap-search" rel="#decathlon-woosmap-search-container">\
            <input class="search_input" onclick="select()" placeholder="'+Messages("woosmap.search.city")+'"/>\
            <span class="search_clear"></span>\
        </div>\
    </div>\
'
module.exports.ResultSearchBox = ' \
    <div class="result_search-box" data-store-id="{{store_id}}"> \
        <a class="result_search-box__link"> \
            <span class="result_search-box__label"> - {{name}}</span> \
        </a>  \
        <span title="search" aria-hidden="true" class="icon icon-directions"></span> \
        {{^user_properties.openingStore}} \
          <div class="result_search-box-hours"> \
              {{#open.open_now}}\
                  <p class="result_search-box-hours__store-openhour">'+Messages("woosmap.store.openhour.start")+' <b>{{open.current_slice.start}} '+Messages("woosmap.store.openhour.end")+' {{open.current_slice.end}}</b</p> \
              {{/open.open_now}}\
              {{^open.open_now}}\
                  <p class="result_search-box-hours__store-closehour">'+Messages("storeview.currentlyClosed")+'</p> \
              {{/open.open_now}} \
          </div> \
        {{/user_properties.openingStore}} \
        {{#user_properties.openingStore}} \
          <div> \
            <p class="result_search-box-hours__store-inopening">' + Messages("woosmap.store.infobox.inopening") + '</b</p> \
          </div> \
        {{/user_properties.openingStore}} \
    </div>\
'
module.exports.ResultSearchItem = '\
    <div id="item" class="item resultsearchitem"> \
        <span title="local" aria-hidden="true" class="icon icon-pin-small pac-icon-marker"></span> \
        <a class="pac-item-query">{{description}}</a>\
    </div>\
'

  var itinary =  '\
          <span title="directions" aria-hidden="true" class="icon icon-directions"></span>  \
          <p>'+Messages("woosmap.search.itinerary")+'</p>\
        '
  var itinary_cn =  '\
        <a href="#" target="_blank" id="infobox-itinerary"><span title="directions" aria-hidden="true" class="icon icon-directions"></span>  \
        <p>'+Messages("woosmap.search.itinerary")+'</p></a>\
        '

module.exports.infobox = '\
<div class="woosmap-infobox"> \
    <div class="woosmap-infobox__store-title"> \
      <p>{{name}}</p> \
    </div>  \
    <div class="woosmap-infobox__container"> \
        <div class="woosmap-infobox__store-opened">{{openlabel}}</div>   \
        <div class="woosmap-infobox__store-title-address">'+Messages("woosmap.store.infobox.address")+'</div>   \
          <div class="woosmap-infobox__store-address">{{address.lines}} </div> \
          <div class="woosmap-infobox__store-city"> {{address.city}} {{address.zip}}</div> \
          <div class="woosmap-infobox__store-website"><a href="{{contact.website}}" target="_blank" rel="noopener">{{hostname}}</a></div> \
        <div class="woosmap-infobox__store-title-address">'+Messages("woosmap.store.infobox.phone")+'</div>   \
          <div class="woosmap-infobox__store-contact">{{contact.phone}}</div> \
          <div class="woosmap-infobox__store-directions">' +
            (window.tc_vars.env_country != 'CN' ? itinary : itinary_cn) +
          '</div>\
          {{^user_properties.openingStore}} \
            {{#open.open_now}}\
              <span class="woosmap-infobox__store-openhour">\
                '+Messages("woosmap.store.openhour.start")+' \
                {{#open.open_hours}}\
                  <b>{{start}} '+Messages("woosmap.store.openhour.end")+' {{end}}</b>\
                {{/open.open_hours}}\
              </span> \
            {{/open.open_now}}\
            {{^open.open_now}}\
              <span class="woosmap-infobox__store-closehour">'+Messages("storeview.currentlyClosed")+'</span> \
            {{/open.open_now}}\
          {{/user_properties.openingStore}} \
          {{#user_properties.openingStore}} \
            <span class="woosmap-infobox__store-inopening">' + Messages("woosmap.store.infobox.inopening") + '</span> \
          {{/user_properties.openingStore}} \
    </div>  \
    <div class="woosmap-infobox__store-button">\
        <a href="#" data-store-id="{{store_id}}" class="woosmap-infobox__store-pagelink">'+Messages("woosmap.store.seestore")+'</a>\
    </div>\
    <img class="woosmap-infobox__border-bottom " src="/assets/images/woosmap-infobox-border.svg" alt="Decathlon" /> \
</div> \
'

module.exports.closestStore = '\
    <div class="closest-store-template"> \
        <div class="closest-store-template__logo"><img width="85" height="31" src="/assets/images/decathlon-logo.svg" alt="Decathlon" /></div> \
        <div class="closest-store-template__container"> \
            <p class="closest-store-template__name">{{name}}</p> \
            <p class="closest-store-template__adress">{{address.lines}} {{address.city}}</p> \
            {{^user_properties.openingStore}} \
                {{#open.open_now}}\
                    <p class="woosmap-infobox__store-openhour">'+Messages("woosmap.store.openhour.start")+' <b>{{open.current_slice.start}} '+Messages("woosmap.store.openhour.end")+' {{open.current_slice.end}}</b</p> \
                {{/open.open_now}}\
                {{^open.open_now}}\
                    <p class="woosmap-infobox__store-closehour">'+Messages("storeview.currentlyClosed")+'</p> \
                {{/open.open_now}} \
            {{/user_properties.openingStore}} \
        </div>\
    </div> \
'

module.exports.travelModeSelector = '\
    <label class="woosmap-form-label geolocation-button"> \
        <span class="woosmap-geolocation-icon"></span> \
    </label> \
    \
    <div class="woosmap-travel-mode"> \
        <div class="pure-g"> \
            <label class="pure-u-1-3 woosmap-travel-mode-option driving selected" data-travel-mode="DRIVING"> \
                <span class="woosmap-travel-mode-icon woosmap-driving-icon"></span> \
            </label> \
    \
            <label class="pure-u-1-3 woosmap-travel-mode-option walking" data-travel-mode="WALKING"> \
                <span class="woosmap-travel-mode-icon woosmap-walking-icon"></span> \
            </label> \
    \
            <label class="pure-u-1-3 woosmap-travel-mode-option transit" data-travel-mode="TRANSIT"> \
                <span class="icon icon-directions_subway"></span> \
            </label> \
        </div> \
        <button type="button" class="close woosmap-travel-close" aria-label="Close">\
            <span aria-hidden="true">&times;</span>\
        </button>\
    </div> \
'

module.exports.directionsSummary = '\
        <div class="woosmap-route-container"> \
            <div class="woosmap-route-info-container"> \
                <div class="route-summary-upper-panel"> \
                    <div style="float:left">{{ summary }}</div> \
                    <div class="woosmap-route-traffic-duration" style="float:right"> \
                        {{#durationInTrafficShort }} {{ durationInTrafficShort }} {{/durationInTrafficShort }} \
                    </div> \
                    <div style="clear:both"></div> \
                </div> \
                <div class="route-summary-lower-panel"> \
                    <div class="woosmap-route-duration" style="float:left">{{ durationShort }} '+Messages("woosmap.direction.circulation")+'</div> \
                    <div style="float:right">{{ distance }}</div> \
                    <div style="clear:both"></div> \
                </div> \
            </div> \
            <div class="woosmap-route-details woosmap-show-steps" data-renderer-index="{{ rendererIndex }}"> \
                <span title="search" aria-hidden="true" class="icon icon-search-blue">\
                </span> \
            </div> \
        </div> \
'

module.exports.directionsOriginDestination = '\
    <div id="directions-box"> \
      <div id="inputs" class="woosmap-directions-inputs"> \
        <div id="directions-travel-mode-selector"></div> \
        <form> \
          <div class="woosmap-directions-origin"> \
            <label class="woosmap-form-label"> \
              <span class="woosmap-directions-icon woosmap-depart-icon"></span> \
            </label> \
            <input type="text" required="required" id="woosmap-directions-origin-input" onclick="select()" class="woosmap-origin" placeholder="Start" autocomplete="on"> \
            <label class="woosmap-form-label-local geolocation-button"> \
                <span class="icon icon-geoloc"></span> \
            </label> \
        <div class="woosmap-directions-icon woosmap-close-icon" title="Clear value"></div> \
          </div> \
          <div class="woosmap-directions-destination"> \
            <label class="woosmap-form-label"> \
              <span class="woosmap-directions-icon woosmap-arrive-icon"></span> \
            </label> \
            <input type="text" required="required" id="woosmap-directions-destination-input" onclick="select()" class="woosmap-destination" placeholder="End" autocomplete="on"> \
            <div class="woosmap-directions-icon woosmap-close-icon" title="Clear value"></div> \
          </div> \
          <span class="woosmap-directions-icon woosmap-reverse-icon woosmap-directions-reverse-input woosmap-toggle-origin-destination" title="Reverse origin &amp; destination"> \
              </span> \
        </form> \
      </div> \
      <div id="directions"> \
        <div id="routes" class="woosmap-directions-routes"></div> \
        <div id="instructions" class="woosmap-directions-instructions" style="display:none"> \
          <div class="instructions-header"> \
            <span class="woosmap-instructions-title">Itinéraire</span> \
            <span id="close-instructions-button" class="close-instructions-button"></span> \
            <div style="clear:both"></div> \
          </div> \
          <div id="instructions-steps"></div> \
        </div> \
        <div id="instructions-mail"></div> \
      </div> \
    </div> \
'


module.exports.directionsMailInput = '\
    <div class="woosmap-mail-container">\
      <div class="woosmap-mobile-form-menu">\
        <label class="woosmap-mobile-label">\
          <span class="woosmap-mobile-icon"></span> Send to mobile\
        </label>\
      </div>\
      <div class="woosmap-mobile-form" style="display: none">\
        <div class="pure-form">\
          <button class="pure-button woosmap-send-button">Send</button>\
        </div>\
      </div>\
    </div>\
    <div id="mail-status"></div>\
'



// WEBPACK FOOTER //
// ./src/modules-es5/pages/store-locator/store-locator-templates.js